import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { t } from 'i18next';
import DataSummarySection from './DataSummarySection';
import ErrorSection from './ErrorSection';
import { 
  DATA_SUMMARY_WITH_ERRORS_MODAL_I18N_KEYS as MY_I18N_KEYS, 
  DATA_SUMMARY_WITH_ERRORS_MODAL_I18N_PREFIX as MY_I18N_PREFIX 
} from '../constants/i18n/DataSummaryWithErrorsModali18nConstants';
import { 
  UPLOAD_FILES_MODAL_I18N_KEYS, 
  UPLOAD_FILES_MODAL_I18N_PREFIX
} from '../constants/i18n/UploadFilesModali18nConstants';
import {
  CONTENT_KEY
} from '../constants/constants';


class DataSummaryWithErrorsModal extends Component {
  static propTypes = {
    show:                                                    PropTypes.bool.isRequired,
    toggleModal:                                             PropTypes.func.isRequired,
    fileInfoAfterValidation:                                 PropTypes.object.isRequired,
    fileValidationErrors:                                    PropTypes.array.isRequired,
    clearUploadedFileAndReturnToUploadFilesOrEditTopicModal: PropTypes.func.isRequired,
    handleRemoveRowsWithErrors:                              PropTypes.func.isRequired,
    totalDataPointsForUploadedFile:                          PropTypes.number.isRequired
  };

  componentDidMount() {
    if (this.props.show) {
      document.body.classList.add('modal-open');
    }
  }

  getI18nText(textKey) {
    return t(MY_I18N_PREFIX + "." + textKey);
  }

  getUploadFilesModalI18nErrorText(textKey) {
    return t(UPLOAD_FILES_MODAL_I18N_PREFIX + "." + textKey);
  }

  determineShouldDisableProceedButton() {
    const {
      fileInfoAfterValidation,
      fileValidationErrors,
      totalDataPointsForUploadedFile
    } = this.props;

    let hasContentColumn  = fileInfoAfterValidation.columns && fileInfoAfterValidation.columns.includes(CONTENT_KEY);
    let isFileEmpty = totalDataPointsForUploadedFile === 0;
    let didFileExceedMaxSizeOrRows = false;
    for (let error of fileValidationErrors) {
      let errorMessage = error.message;
      if (
        errorMessage === this.getUploadFilesModalI18nErrorText(UPLOAD_FILES_MODAL_I18N_KEYS.exceeded_max_number_of_rows_error_message) ||
        errorMessage === this.getUploadFilesModalI18nErrorText(UPLOAD_FILES_MODAL_I18N_KEYS.exceeded_max_file_size_error_message)
      ) {
        didFileExceedMaxSizeOrRows = true;
      }
    }

    return (!hasContentColumn || isFileEmpty || didFileExceedMaxSizeOrRows);
  }

  render() {
    const {
      show,
      toggleModal,
      fileInfoAfterValidation,
      fileValidationErrors,
      clearUploadedFileAndReturnToUploadFilesOrEditTopicModal,
      handleRemoveRowsWithErrors,
      totalDataPointsForUploadedFile
    } = this.props;

    const shouldDisableProceedButton = this.determineShouldDisableProceedButton();

    return (
      <div className={`modal create-upload-data-topic-modal data-summary-modal ${show ? 'modal-show' : 'modal-hide'}`}>
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <span className="create-upload-data-topic-modal-title">
                {this.getI18nText(MY_I18N_KEYS.modal_title)}
              </span>
              <button
                onClick={() => toggleModal(false)}
                onKeyDown={() => {}}
                className="modal-close-button"
              >
                <i className="la la-close modal-close" />
              </button>
            </div>
            <DataSummarySection
              fileInfoAfterValidation={fileInfoAfterValidation}
              totalDataPointsForUploadedFile={totalDataPointsForUploadedFile}
              includeMissingValue={true}
              displayLanguageSelection={false}
            />
            <ErrorSection
              fileValidationErrors={fileValidationErrors}
            />
            <div className="modal-footer">
              <button
                type="button"
                className='btn variable-width-btn'
                onClick={clearUploadedFileAndReturnToUploadFilesOrEditTopicModal}
              >
                {this.getI18nText(MY_I18N_KEYS.select_another_file_button_text)}
              </button>
              <button
                type="submit"
                className='btn btn-submit variable-width-btn'
                onClick={handleRemoveRowsWithErrors}
                disabled={shouldDisableProceedButton}
              >
                {this.getI18nText(MY_I18N_KEYS.remove_rows_with_errors_and_proceed_button_text)}
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default DataSummaryWithErrorsModal;



// WEBPACK FOOTER //
// ./src/features/topics/components/file-upload/DataSummaryWithErrorsModal.js